<div class="tab" [class.active]="active()">
  <div class="icon" [innerHTML]="safeIcon()">
   
  </div>
  <span>{{label()}}</span>
</div>